//统一管理api
// import { base_pets_cdwar } from "./base"; // 导入接口域名列表
// import { post, _post } from "./tool"; // 导入http中创建的axios实例
export default {};
